module.exports = __webpack_public_path__ + "img/gratitude-journal_B095L11GVZ.f2ded7b3.jpg";